import { render, staticRenderFns } from "./PayDetail.vue?vue&type=template&id=03ad5321&scoped=true&"
import script from "./PayDetail.vue?vue&type=script&lang=js&"
export * from "./PayDetail.vue?vue&type=script&lang=js&"
import style0 from "./PayDetail.vue?vue&type=style&index=0&id=03ad5321&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ad5321",
  null
  
)

export default component.exports